import type { ResourceConfig } from "../types";

export const coachReportConfig = {
  displayName: "教练日报",
  category: "coach-report",
  permissions: {
    "read:all": {
      label: "查看所有教练日报",
      description: "可以查看所有教练的每日分析报告",
    },
    "read:assigned": {
      label: "查看自己的日报",
      description: "只能查看自己的每日分析报告",
    },
  },
  navigation: {
    path: "/dashboard/coach-daily-analysis",
    label: "每日分析",
    icon: "MessageSquareText" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    order: 15,
  },
} satisfies ResourceConfig;
